<template>
    <div id="list-ouvrage-equipment-component" class="pa-4">
        <in-progress-component/>
    </div>
</template>

<script>
import InProgressComponent from "@/components/Error/InProgressComponent";

export default {
    name: "ListOuvrageEquipmentComponent",
    components: {InProgressComponent}
}
</script>